import React, { useEffect } from 'react';
import styles from './SuccessAnimation.module.css';
import { FaThumbsUp } from 'react-icons/fa';

const SuccessAnimation = ({ onComplete }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            if (onComplete) onComplete();
        }, 2500);
        return () => clearTimeout(timer);
    }, [onComplete]);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.iconWrapper}>
                    <FaThumbsUp className={styles.thumbsUp} />
                    <div className={styles.sparkle} style={{'--i': 1}}></div>
                    <div className={styles.sparkle} style={{'--i': 2}}></div>
                    <div className={styles.sparkle} style={{'--i': 3}}></div>
                </div>
                <span className={styles.text}>ok!</span>
            </div>
        </div>
    );
};

export default SuccessAnimation;
